import { css } from '@emotion/core';

import { boxShadowGrey } from 'src/design-system/mixins';
import { Theme } from 'src/design-system/theme';

import type { Props } from './EmptyState';

const getBorder =
  (border = false) =>
  (theme: Theme) => {
    if (border) return `1px dashed ${theme.colors.dark}`;
    return 'none';
  };

export const emptyStateStyle =
  ({ border = false, whiteSpaceClickable, fullWidth = true, shadow = false }: Props) =>
  (theme: Theme) =>
    css`
      width: ${fullWidth ? '100%' : 'auto'};
      background: ${theme.colors.light};
      border: ${getBorder(border)(theme)}; /* TODO: fix! */
      cursor: ${whiteSpaceClickable ? 'pointer' : 'default'};
      ${shadow && boxShadowGrey(1)}
    `;
